// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ek-6";
export var emphasizeQuantity = "_ek-3";
export var flatBottomCorners = "_ek-5";
export var productImage = "_ek-0";
export var quantityContainer = "_ek-2";
export var tooltip = "_ek-1";
export var wrapAndEllipsesOverflow = "_ek-4";